export default __webpack_public_path__ + "static/media/headerBigodes.916d31f3.png";